export default __webpack_public_path__ + "static/media/bitcoin3.50028aaf.jpg";